<mat-form-field *ngIf="visible && (ready$ | async)" color="accent">
  <mat-label>Analysis Mode</mat-label>
  <mat-select [disabled]="disabled || schemas.length <= 1" [(ngModel)]="dropdownModel" (valueChange)="updateSelection($event)">
    <mat-option *ngIf="schemas.length > 1 && !disableMultiRetailer && !singleRetailerOnly" [value]="primarySchema"> Multi-Retailer </mat-option>
    <mat-option *ngFor="let r of schemas" [value]="r"> {{ r | retailerDisplay }}</mat-option>
  </mat-select>
</mat-form-field>
